const DEFAULT_ALPHA_ACCESS_URL = "/alpha";

// Reversible release guard. Keep the Alpha implementation intact while public
// entry points and direct form access are paused.
export const ALPHA_ACCESS_ENABLED = false;

export function alphaAccessUrl(): string {
  const configured =
    import.meta.env.VITE_ALPHA_ACCESS_URL?.trim() || DEFAULT_ALPHA_ACCESS_URL;
  try {
    const url = new URL(configured, window.location.origin);
    const localHttp =
      url.protocol === "http:" &&
      (url.hostname === "127.0.0.1" || url.hostname === "localhost");
    return url.protocol === "https:" || localHttp
      ? url.toString()
      : DEFAULT_ALPHA_ACCESS_URL;
  } catch {
    return DEFAULT_ALPHA_ACCESS_URL;
  }
}

export function alphaFeedbackUrl(): string | null {
  const configured = import.meta.env.VITE_ALPHA_FEEDBACK_URL?.trim();
  if (!configured) return null;
  try {
    const url = new URL(configured);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
}
